import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessageTitleNonFinal: {
		id: 'new-issue-create-trigger.use-prefilled-default-values.error-message-title-non-final',
		defaultMessage: "We weren't able to open the issue create modal!",
		description: 'Error message when prefilling for fields fail due to bad data',
	},
	errorMessageDescriptionNonFinal: {
		id: 'new-issue-create-trigger.use-prefilled-default-values.error-message-description-non-final',
		defaultMessage: 'Please try again or contact your administrator if the problem persists.',
		description: 'Error message when prefilling for fields fail due to bad data',
	},
	errorMessageTitleNonFinalIssueTerminologyRefreshM4: {
		id: 'new-issue-create-trigger.use-prefilled-default-values.error-message-title-non-final-issue-terminology-refresh-m4',
		defaultMessage: "We weren't able to open the work item create modal",
		description: 'Error message when prefilling for fields fail due to bad data',
	},
});
